import { useContext, useMemo } from "react"
import { ArchivedChatContext } from "@/contexts/ArchivedChatContext"
import { useAppSelector } from "@/reducers/hooks"
import { Message } from "@/reducers/messagesSlice"
import {
  selectActiveChat,
  selectDocumentDriverContext,
  selectDocumentMetadata,
} from "@/reducers/chatsSliceSelectors"
import { selectChatMessages } from "@/reducers/messagesSliceSelectors"

type UseCMRMetadataReturn = {
  documentMetadata: ReturnType<typeof selectDocumentMetadata>
  driverContext: ReturnType<typeof selectDocumentDriverContext>
  hasCMRMetadata: boolean
}

const useCMRMetadata = (message?: Message): UseCMRMetadataReturn => {
  const activeChat = useAppSelector(selectActiveChat)
  const activeChatMessages = useAppSelector(selectChatMessages(activeChat.jid))
  const archivedChatMessages = useContext(ArchivedChatContext)
  const chatMessages = archivedChatMessages?.chatMessages ?? activeChatMessages

  const documentMetadata = selectDocumentMetadata(chatMessages, message?.id)
  const driverContext = selectDocumentDriverContext(chatMessages, message?.id)

  const hasCMRMetadata = useMemo(
    () => Boolean(documentMetadata?.data || driverContext),
    [documentMetadata?.data, driverContext],
  )

  return {
    documentMetadata,
    driverContext,
    hasCMRMetadata,
  }
}

export default useCMRMetadata
